module.exports = __webpack_public_path__ + "static/media/Waitless.f7f6835b.jpg";